"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { trackEvent } from "@/utils/analytics";

function RequestPage() {
  const path = usePathname();
  useEffect(() => {
    trackEvent("page_view", path, {
      referrer_page: document.referrer || "",
    });
  }, []);

  return <></>;
}

export default RequestPage;
